import React, { useEffect, useState } from "react";
import classes from "./WorkStages.module.scss";
import chevronUp from "../../media/icons/chevron-up.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-scroll";
import {tabsName, tabsBlocks} from "./const.ts";

const WorkStages = () => {
  const { t, i18n } = useTranslation();

  const [activeTab, setActiveTab] = useState("Strategic IT Consulting");
  const [openedBlock, setOpenedBlock] = useState(null);
  const [dropDownBlocks, setDropDownBlocks] = useState<
    { title: string; content: string[]; imageUrl: string }[] | null
  >([]);

  const openBlockHandler = (index) => {
    openedBlock === index ? setOpenedBlock(null) : setOpenedBlock(index);
  };

  useEffect(() => {
    setDropDownBlocks(tabsBlocks[activeTab]);
   

    if (activeTab === "Strategic IT Consulting") {
      setOpenedBlock(0);
    } else {
      setOpenedBlock(null);
    }
  }, [i18n.language, activeTab]);


  return (
      <div className={classes['stages-container']}>
        <div className={classes['tabs-container']}>
          {tabsName.map((tab, index) => <button key={tab} onClick={()=>setActiveTab(tab)} className={`${classes['tab-wrapper']} ${activeTab === tab ? classes.selected : ''}`}><span key={index}>{t('home.tabs.'+tab.replaceAll(" ", ""))}</span></button>)}
        </div>

        <div className={classes["container"]}>
          <div className={classes["left"]}>
            <h2 className={classes["header"]}>{t('home.tabs.'+activeTab.replaceAll(" ", ""))}</h2>
            <p className={classes["text"]}>{t('home.tabsContent.'+activeTab.replaceAll(" ", ""))}</p>
            <Link className={classes["connect-button"]} smooth={true} to="contact">
              {t("buttons.connect")}
            </Link>
          </div>

          <div className={classes["right"]}>
            <div className={classes["drop-down"]}>
              {dropDownBlocks.map((block, index) => (
                <div
                  key={index}
                  id={index.toString()}
                  className={classes["drop-down__block"]}
                >
                  <div
                    className={classes["top"]}
                    onClick={() => openBlockHandler(index)}
                  >
                    <div className={classes["drop-down__block__title"]}>
                      {t(block.title)}
                    </div>
                    <img
                      className={`${classes["chevron"]} ${classes[`chevron--${openedBlock === index ? "up" : "down"}`]}`}
                      src={chevronUp}
                      alt="chevron"
                    />
                  </div>

                  <div
                    className={`${classes["drop-down__content"]} ${
                      openedBlock === index ? classes["visible"] : classes["hidden"]
                    }`}
                  >
                    <img src={block.imageUrl} alt={t(block.title)} />

                    {block.content.map((text) => (
                      <p key={text}>{t(text)}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  );
};

export default WorkStages;
